// src/hooks/order/useOrderModals.ts
// Hook para manejar todos los estados de modales y submit del formulario de pedidos

import { useState, useCallback } from 'react'

interface UseOrderModalsReturn {
  // Estados de modales
  modals: {
    note: boolean
    audit: boolean
    tracking: boolean
    shippingLabel: boolean
    invoiceUpload: boolean
  }
  // Estado de submit
  isSubmitting: boolean
  // Funciones para abrir modales
  openModal: (modalName: 'note' | 'audit' | 'tracking' | 'shippingLabel' | 'invoiceUpload') => void
  // Funciones para cerrar modales
  closeModal: (modalName: 'note' | 'audit' | 'tracking' | 'shippingLabel' | 'invoiceUpload') => void
  // Funciones individuales para compatibilidad con componentes existentes
  setShowNoteModal: (show: boolean) => void
  setShowAuditModal: (show: boolean) => void
  setShowTrackingModal: (show: boolean) => void
  setShowShippingLabelModal: (show: boolean) => void
  setShowInvoiceUploadModal: (show: boolean) => void
  // Funciones para manejar submit
  setIsSubmitting: (isSubmitting: boolean) => void
}

export function useOrderModals(): UseOrderModalsReturn {
  const [showNoteModal, setShowNoteModal] = useState(false)
  const [showAuditModal, setShowAuditModal] = useState(false)
  const [showTrackingModal, setShowTrackingModal] = useState(false)
  const [showShippingLabelModal, setShowShippingLabelModal] = useState(false)
  const [showInvoiceUploadModal, setShowInvoiceUploadModal] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const openModal = useCallback((modalName: 'note' | 'audit' | 'tracking' | 'shippingLabel' | 'invoiceUpload') => {
    switch (modalName) {
      case 'note':
        setShowNoteModal(true)
        break
      case 'audit':
        setShowAuditModal(true)
        break
      case 'tracking':
        setShowTrackingModal(true)
        break
      case 'shippingLabel':
        setShowShippingLabelModal(true)
        break
      case 'invoiceUpload':
        setShowInvoiceUploadModal(true)
        break
    }
  }, [])

  const closeModal = useCallback((modalName: 'note' | 'audit' | 'tracking' | 'shippingLabel' | 'invoiceUpload') => {
    switch (modalName) {
      case 'note':
        setShowNoteModal(false)
        break
      case 'audit':
        setShowAuditModal(false)
        break
      case 'tracking':
        setShowTrackingModal(false)
        break
      case 'shippingLabel':
        setShowShippingLabelModal(false)
        break
      case 'invoiceUpload':
        setShowInvoiceUploadModal(false)
        break
    }
  }, [])

  return {
    modals: {
      note: showNoteModal,
      audit: showAuditModal,
      tracking: showTrackingModal,
      shippingLabel: showShippingLabelModal,
      invoiceUpload: showInvoiceUploadModal
    },
    isSubmitting,
    openModal,
    closeModal,
    setShowNoteModal,
    setShowAuditModal,
    setShowTrackingModal,
    setShowShippingLabelModal,
    setShowInvoiceUploadModal,
    setIsSubmitting
  }
}

